import { useMutation } from '@tanstack/react-query'

import { updateSiteNotificationPreferences } from '@/features/site/endpoints/sites'
import type { SiteNotificationPreferencesRequest } from '@/features/site/types/site'

export type UseSiteNotificationPreferencesMutationResult = ReturnType<
  typeof useUpdateSiteNotificationPreferencesMutation
>

export function useUpdateSiteNotificationPreferencesMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (variables: { siteUuid: string; location: string; payload: SiteNotificationPreferencesRequest }) =>
      updateSiteNotificationPreferences(variables.siteUuid, variables.location, variables.payload),
  })

  return {
    updateSiteNotificationPreferences: mutateAsync,
    ...mutationResult,
  }
}
